; (function (global, factory) {
    typeof define === 'function' && define.amd ? define('MM/Components/ClientPortal/HeaderNavigation',["jquery", "eventManager", 'MM/Utils/notifier'], factory) :
        typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery"), require("eventManager"), require('MM/Utils/notifier')) :
            console && console.error('HeaderNavigation does not support non-amd script loading.');
}(this/* window */, function ($, eventManager, notifier) {

    function HeaderNavigation(scope, SignInSignUpButtonUrl, IsExternalSignOut, InternalSignOutUrl, IsSignedIn, TooltipDelayInDays) {
        this._loadDependencies();

        Object.defineProperties(this, {
            scope: { enumerable: !1, configurable: !0, writable: !1, value: scope },
            $scope: { enumerable: !0, configurable: !0, writable: !1, value: $(scope) },
            signInSignUpButtonUrl: { enumerable: !0, configurable: !0, writable: !1, value: SignInSignUpButtonUrl },
            isExternalSignOut: { enumerable: !0, configurable: !0, writable: !1, value: IsExternalSignOut },
            internalSignOutUrl: { enumerable: !0, configurable: !0, writable: !1, value: InternalSignOutUrl },
            toastMessagesRoot: { writable: !1, configurable: !0, enumerable: !0, value: scope.querySelector('.js-toast-notifications') },
            isSignedIn: { enumerable: !0, configurable: !0, writable: !1, value: IsSignedIn },
            tooltipDelayInDays: { enumerable: !0, configurable: !0, writable: !1, value: TooltipDelayInDays },
            headerTooltip: { writable: !1, configurable: !0, enumerable: !0, value: $('#header-tooltip', scope) }
        });

        var signInSignUpBtn = this.scope.querySelector(".mm-sign-up-sign-in");
        if (signInSignUpBtn) signInSignUpBtn.addEventListener('click', this.signInSignUpClickHandler.bind(this));

        if (this.isExternalSignOut === false) {
            var signOutBtn = this.scope.querySelector(".signout-link");
            if (signOutBtn) signOutBtn.addEventListener('click', this.internalSignOut.bind(this));
        }

        if (this.isSignedIn && this.isHeaderTooltipRequired()) {
            this.headerTooltip.tooltip({
                html: true,
                placement: "auto bottom",
                trigger: "manual"
            }).tooltip("show");

            var tooltipId = this.headerTooltip.attr("aria-describedby");
            $("#" + tooltipId).on("click", this.hideHeaderTooltip.bind(this));
            $(".mm-authenticated-avatar").on("click", this.hideHeaderTooltip.bind(this));
        }
    }

    HeaderNavigation.prototype.isHeaderTooltipRequired = function isHeaderTooltipRequired() {
        if (!window.localStorage.getItem('headerNavigation.showTooltip')) return true;
        
        var lastShownOn = window.localStorage.getItem('headerNavigation.showTooltip');

        var diffInMilliseconds = Date.now() - lastShownOn;
        var diffInDays = diffInMilliseconds / (1000 * 3600 * 24);//diffInMilliseconds / number of ms in a day(86400000)

        if (diffInDays > this.tooltipDelayInDays) return true;

        return false;
    }

    HeaderNavigation.prototype.hideHeaderTooltip = function hideHeaderTooltip() {
        this.headerTooltip.tooltip('hide');
        window.localStorage.setItem('headerNavigation.showTooltip', Date.now());
    }

    HeaderNavigation.prototype.signInSignUpClickHandler = function signInSignUpClickHandler(e) {
        e.preventDefault();

        var formAuth = document.createElement("form");
        formAuth.method = "POST";
        formAuth.action = this.signInSignUpButtonUrl;
        document.body.appendChild(formAuth);

        formAuth.submit();
    }

    HeaderNavigation.prototype.internalSignOut = function internalSignOut(e) {
        var loaderEl = this._generateLoader();
        document.body.appendChild(loaderEl);

        fetch(this.internalSignOutUrl, { method: 'POST' }).then(function(resp) {
            if(!resp.ok) throw new Error(resp.statusText);

            window.location = '/';
        }).catch((function(err) {
            console && console.error instanceof Function && console.error(err);
            return this.signOutClientPortalErrorMessageAsync();
        }).bind(this));
    }

    HeaderNavigation.prototype.signOutClientPortalErrorMessageAsync = function signOutClientPortalErrorMessageAsync() {
        return new Promise((function(resolve, reject){
            var msgEl = this._getMessageNode('.js-toast-clientportal-error');
            if(!msgEl) {
                console && console.log('cannot find sign out client portal message.');
                reject();
                return;
            }

            this.notifier.pushErrorAsync(msgEl).then(resolve, reject);
        }).bind(this));
    }

    HeaderNavigation.prototype._getMessageNode = function _getMessageNode(messageSelector) {
        var msgEl = this.toastMessagesRoot.querySelector(messageSelector);
        if(!msgEl) return null;

        var fragment = document.createDocumentFragment();

        // copy children to a fragment, so we can avoid inserting a placeholder into the toast message
        [].forEach.call(msgEl.childNodes, function(el) { fragment.appendChild(el.cloneNode(!0));}, this);

        return fragment;
    }

    HeaderNavigation.prototype._generateLoader = function _generateLoader() {
        var loaderEl = this.scope.querySelector('.js-loader').cloneNode(!0);
        // by default loader is hidden, so we need to make it visible
        loaderEl.classList.remove('hidden');
        return loaderEl;
    }

    HeaderNavigation.prototype._loadDependencies = function _loadDependencies()  {
        Object.defineProperty(this, 'notifier', {configurable: !0, enumerable: !1, writable: !1, value: new notifier() });
    }

    HeaderNavigation.init = function init(args) {
        if (args.IsExperienceEditorEditing === !0) return null;

        return new HeaderNavigation(args.scope,
            args.SignInSignUpButtonUrl,
            args.IsExternalSignOut,
            args.InternalSignOutUrl,
            args.IsSignedIn,
            args.TooltipDelayInDays);
    }

    return HeaderNavigation;
}));
